import React from 'react';
import './Cart.css'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Card } from 'react-bootstrap';
const Cart = ({ cart }) => {
    const { img, name } = cart;
    // console.log(cart);
    return (
        <div className='cart mt-1'>
            <Card style={{ width: '18rem' }}>
                <div className="row p-2">
                    <div className="col-md-6">
                        <img src={img} alt="" />
                    </div>
                    <div className="col-md-6">
                        <p>{name} <FontAwesomeIcon icon={faTrash} /></p>
                    </div>


                </div>
            </Card>
        </div>
    );
};

export default Cart;